import { forEach } from "lodash";
// keys 예시
// const keys = [
//   { idx: 1, key: "category", type: String },
//   { idx: 2, key: "code", type: String },
//   { idx: 3, key: "division", type: String },
//   { idx: 4, key: "name", type: String },
//   { idx: 5, key: "size", type: String },
//   { idx: 6, key: "unit", type: String },
//   { idx: 7, key: "buyPrice", type: Number },
//   { idx: 8, key: "sellPrice", type: Number },
//   { idx: 9, key: "memo", type: String },
// ];

const excelUploadData = ({ keys, rows }) => {
  let items = [];
  // 첫번째 로우는 삭제
  const _rows = rows.filter((row, idx) => idx !== 0);
  // key의 idx와 row data의 idx가 동일하면 합쳐줌
  forEach(_rows, (row) => {
    forEach(row, (data) => {
      forEach(keys, (key) => {
        if (data.idx === key.idx) Object.assign(data, key);
      });
    });
  });
  //  key 와 value 매치
  forEach(_rows, (row) => {
    forEach(row, (data, index) => {
      const { key, value, type } = data;
      row[index] = { [key]: type(value) };
    });
  });
  // 각 row의 배열을 하나의 오브젝트로 변환
  items = _rows.map((row) => {
    return Object.assign({}, ...row);
  });

  return items;
};

export { excelUploadData };
